import styled from 'styled-components';

export const Container = styled.h1`
  margin-bottom: 1rem;
  line-height: 2.4rem;
  color: ${({ theme }) => theme.colors.textPrimary};
`;
